export default __webpack_public_path__ + "static/media/topza.acdecddc.svg";